import { render, staticRenderFns } from "./ActiveClass.vue?vue&type=template&id=675f596f&"
import script from "./ActiveClass.vue?vue&type=script&lang=js&"
export * from "./ActiveClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports